(function(){
  "use strict";

  /* ============ HEADER SCROLL ============ */
  var headerEl = document.getElementById("siteHeader");
  if(headerEl){
    var onScroll = function(){
      headerEl.classList.toggle("scrolled", window.scrollY > 60);
    };
    window.addEventListener("scroll", onScroll, {passive:true});
    onScroll();
  }

  /* ============ MOBILE NAV ============ */
  var burger = document.querySelector(".burger");
  if(burger && headerEl){
    burger.addEventListener("click", function(){
      var open = headerEl.classList.toggle("menu-open");
      burger.setAttribute("aria-expanded", open ? "true" : "false");
      document.body.style.overflow = open ? "hidden" : "";
    });
    document.querySelectorAll(".mobile-nav a").forEach(function(a){
      a.addEventListener("click", function(){
        headerEl.classList.remove("menu-open");
        document.body.style.overflow = "";
      });
    });
  }

  /* ============ REVEAL ON SCROLL ============ */
  if("IntersectionObserver" in window){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){ e.target.classList.add("in"); io.unobserve(e.target); }
      });
    },{threshold:0.15});
    document.querySelectorAll(".reveal").forEach(function(el){ io.observe(el); });
  } else {
    document.querySelectorAll(".reveal").forEach(function(el){ el.classList.add("in"); });
  }

  /* ============ CART COUNT (shared across sections) ============ */
  window.MrRoses = window.MrRoses || {};
  window.MrRoses.refreshCartCount = function(){
    fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root + "cart.js" : "/cart.js", {
      headers: {"Accept":"application/json"}
    }).then(function(r){ return r.json(); }).then(function(cart){
      document.querySelectorAll("[data-cart-count]").forEach(function(el){
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      });
      document.dispatchEvent(new CustomEvent("cart:updated", {detail:{cart:cart}}));
    }).catch(function(){});
  };

  /* ============ NEWSLETTER (progressive enhancement) ============ */
  document.querySelectorAll(".news-form").forEach(function(form){
    form.addEventListener("submit", function(evt){
      if(typeof form.checkValidity === "function" && !form.checkValidity()) return;
      evt.preventDefault();
      var formData = new FormData(form);
      var scope = form.closest(".news-strip") || form;
      var messageEl = scope.querySelector("[data-newsletter-message]");
      fetch(form.action, {method:"POST", body:formData, headers:{"Accept":"application/json"}})
        .then(function(){
          if(messageEl){
            messageEl.textContent = messageEl.getAttribute("data-success");
            messageEl.className = "news-message success";
          }
          form.reset();
        })
        .catch(function(){
          if(messageEl){
            messageEl.textContent = messageEl.getAttribute("data-error");
            messageEl.className = "news-message error";
          }
        });
    });
  });
})();
